module.exports = __webpack_public_path__ + "img/DE00697.cc5c1fc2.png";